import { defineComponent } from '@vue/composition-api';
import { useFormat } from 'vivat';

import DeliveryNoteStatusRenderer from '@/components/DeliveryNote/DeliveryNoteStatusRenderer.vue';

const toDecimalFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    uniqueId: {
      name: 'ใบจัดรถขนส่ง',
      width: '1fr',
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      component: defineComponent({
        render(createElement: any) {
          return createElement(
            DeliveryNoteStatusRenderer,
            {
              attrs: {
                status: (this as any).row.item.status,
                deliveries: (this as any).row.item.deliveries,
              },
              props: { row: {} },
            },
          );
        },
        props: { row: {} },
      }),
      filter: () => '',
    },
    area: {
      name: 'เขตจัดส่ง',
      width: '0.8fr',
      class: 'text-center',
    },
    'driver.name': {
      name: 'ชื่อคนขับรถ',
      width: '1.25fr',
    },
    deliveryManCount: {
      name: 'จำนวน ผู้ช่วย',
      width: '6rem',
      class: 'text-center',
    },
    'vehicle.license': {
      name: 'ทะเบียนรถ',
      width: '0.8fr',
    },
    totalWeight: {
      name: 'น้ำหนักรวม (Kg.)',
      width: '8rem',
      class: 'text-right',
    },
    distanceTravelled: {
      name: 'ระยะทางระบบประเมิน / วิ่งจริง (Km.)',
      width: '9rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string, row: any) => `${toDecimalFormat(row.item?.apiCalculateDistance || 0)} / ${toDecimalFormat(val)}`,
    },
    totalAmount: {
      name: 'จำนวนบิลส่งของ',
      width: '5rem',
      class: 'text-center',
    },
    createdBy: {
      name: 'ทำรายการโดย',
      width: '8rem',
      class: 'text-right',
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return row.item.createdBy !== null ? row.item.createdBy.name : '';
      },
    },
    updatedAt: {
      name: 'วันที่ทำรายการ',
      width: '11rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
  },
  sortable: [
    'uniqueId',
    'updatedAt',
    'status',
    // 'deliveryArea',
    'deliveryManCount',
  ],
};
